import { Button, Form } from 'react-bootstrap';
import { PAGE_SIZES } from '../useFinanceQuery';

// Prev / Page N of M / Next + page-size select. Driven by useFinanceQuery (URL-synced ?page=&limit=).
export default function FinancePagination({ page, totalPages, limit, hasMore, onPage, onLimit, synthetic }) {
  const canPrev = page > 1;
  const canNext = hasMore || page < totalPages;

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3">
      <div className="d-flex align-items-center gap-2">
        <Button size="sm" variant="outline-secondary" disabled={!canPrev} onClick={() => onPage(page - 1)}>
          ‹ Prev
        </Button>
        <span className="small text-muted">
          Page {page}{totalPages > 1 ? ` of ${totalPages}` : ''}
        </span>
        <Button size="sm" variant="outline-secondary" disabled={!canNext} onClick={() => onPage(page + 1)}>
          Next ›
        </Button>
      </div>
      <div className="d-flex align-items-center gap-2">
        {synthetic && (
          <span className="small text-muted">server pagination unavailable — showing all rows</span>
        )}
        <Form.Label className="small text-muted mb-0">Per page</Form.Label>
        <Form.Select
          size="sm"
          style={{ width: 'auto' }}
          value={limit}
          onChange={(e) => onLimit(Number(e.target.value))}
        >
          {PAGE_SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
        </Form.Select>
      </div>
    </div>
  );
}
